import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import SectionTitle from '../../components/SectionTitle';
import PrevArrowSVG from '../../components/SVG';
import NextArrowSVG from '../../components/SVG/NextArrowSVG';
import SingleTestimonial from '../../components/Testimonial';

import avatarImg1 from '../../assets/img/testimonial/avatar-1.png';
import avatarImg2 from '../../assets/img/testimonial/avatar-2.png';
import avatarImg3 from '../../assets/img/testimonial/avatar-3.png';

const Testimonial = () => {
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '3',
    spaceBetween: 30,
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
    navigation: {
      prevEl: '.slider-prev',
      nextEl: '.slider-next',
    },
  };

  return (
    <div className="it-testimonial-area fix black-bg pt-150 pb-150">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-4 col-lg-5">
            <div className="it-testimonial-left">
              <SectionTitle
                itemClass="it-testimonial-title-box mb-45"
                subTitleClass="it-section-subtitle"
                subTitle="Testimonial"
                titleClass="it-section-title text-white"
                title="A Place Of Trust for Millions Of People"
              />

              <div className="it-testimonial-arrow-box">
                <button className="slider-prev">
                  <span>
                    <PrevArrowSVG />
                  </span>
                </button>
                <button className="slider-next">
                  <span>
                    <NextArrowSVG />
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div className="col-xl-8 col-lg-7">
            <div className="it-testimonial-wrapper">
              <div className="swiper-container it-testimonial-active">
                <Swiper
                  modules={[Navigation]}
                  {...sliderOption}
                  className="swiper-wrapper"
                >
                  <SwiperSlide className="swiper-slide">
                    <SingleTestimonial
                      description={`“Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Ut enim ad minim veniam, quis
                          nostrud exercitation ullamco laboris”`}
                      authorAvatar={avatarImg1}
                      authorName="Fiona Perkins"
                      designation="Project Manger"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleTestimonial
                      description={`“Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Ut enim ad minim veniam, quis
                          nostrud exercitation ullamco laboris”`}
                      authorAvatar={avatarImg2}
                      authorName="John Berger"
                      designation="UI/UX Designer"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleTestimonial
                      description={`“Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Ut enim ad minim veniam, quis
                          nostrud exercitation ullamco laboris”`}
                      authorAvatar={avatarImg1}
                      authorName="Fiona Perkins"
                      designation="Project Manger"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleTestimonial
                      description={`“Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Ut enim ad minim veniam, quis
                          nostrud exercitation ullamco laboris”`}
                      authorAvatar={avatarImg3}
                      authorName="Yolanda R. Renninger"
                      designation="WordPress developer"
                    />
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
